import { Button, DialogActions } from '@mui/material';
import React, { memo } from 'react';
import { useStackModalContext } from '../context/StackModalContext';

/**
 * Component for rendering the action buttons of the stack modal
 */
const StackModalActions: React.FC<{ onClose: () => void }> = ({ onClose }) => {
  const context = useStackModalContext();

  if (!context) {
    throw new Error(
      'StackModalActions must be used within a StackModalProvider',
    );
  }

  const {
    actions: {
      form: { handleSave },
    },
    state: { isSaving },
  } = context;

  return (
    <DialogActions>
      <Button onClick={onClose}>Cancel</Button>
      <Button
        variant='contained'
        color='primary'
        onClick={handleSave}
        disabled={isSaving}
      >
        Save
      </Button>
    </DialogActions>
  );
};

export default memo(StackModalActions);
